<!-- <div class="form-group m-form__group row">
	<label class="col-form-label col-lg-3 col-sm-12" *ngIf="data.label">
		{{data.label}}
	</label>
	<div [ngClass]="data.class ? data.class : 'col-lg-6 col-md-9 col-sm-12'">
		<div class="custom-file">
			<input type="file" class="custom-file-input" id="customFile" (change)="onFileChange($event)">
			<label class="custom-file-label" for="customFile">
				<span *ngIf="file">{{file.name}}</span>
				<span *ngIf="!file && !data.placeholder">Choose File</span>
				<span *ngIf="data.placeholder">{{data.placeholder}}</span>
			</label>
		</div>
		<span class="m-form__help" [style.color]="(fileUploadErrorMessage === 'No File Uploaded Yet')? 'black' : 'red'">{{fileUploadErrorMessage}}</span>
	</div>
	<div class="col-lg-2 col-md-2 col-sm-12" *ngIf="file">
		<ng-container *ngIf="isValidFile">
			<a href="javascript:;" style="margin-top:30px;" *ngIf="!data.uploadButton; else elseButton" (click)="uploadFile()">Submit</a>
			<ng-template #elseButton>
				<button type="button" class="btn btn-secondary" (click)="uploadFile()">
					{{data.uploadButton}}
				</button>
			</ng-template>
		</ng-container>
	</div>
</div> -->

<ng-container *ngIf="!disabled">
	<div class="custom-file">
		<input type="file" [disabled]="disabled" class="custom-file-input" id="customFile" (change)="onFileChange($event)">
		<label class="custom-file-label" for="customFile">
			<span *ngIf="file">{{file.name}}</span>
			<span *ngIf="!file && !data.placeholder">Choose File</span>
			<span *ngIf="data.placeholder">{{data.placeholder}}</span>
		</label>
	</div>
	<span class="m-form__help" [style.color]="(fileUploadErrorMessage === 'No File Uploaded Yet')? 'black' : 'red'">{{fileUploadErrorMessage}}</span>
</ng-container>
<div class="col-lg-2 col-md-2 col-sm-12" *ngIf="file">
	<ng-container *ngIf="isValidFile">
		<a href="javascript:;" style="margin-top:30px;" *ngIf="!data.uploadButton; else elseButton" (click)="uploadFile()">Submit</a>
		<ng-template #elseButton>
			<button type="button" class="btn btn-secondary" (click)="uploadFile()">
				{{data.uploadButton}}
			</button>
		</ng-template>
	</ng-container>
</div>